import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getTopSellingProducts } from "../../service/api_calls/ordersReports/OrderReportsAPi";
import {
  getOrderReportAvg,
  getOrderReportByCity,
  getOrderReportByType,
  getOrderSummaryAnalysis,
} from "../../service/api_calls/orderSummary/orderSummaryApi";
import {
  formatDaysTimePeriod,
  transformDateRangeSalesData,
  transformSalesData,
  transformDateRangeSalesDataByDay,
} from "./orderSummaryHelper";

const initialState = {
  orderSaleAmtTableMonthData: null,
  orderSaleAmtTableMonthDataLoader: false,

  orderSaleAmtTableMonthPreviousYearData: null,
  orderSaleAmtTableMonthPreviousYearDataLoader: false,

  orderSaleAmtYearData: null,
  orderSaleAmtYearDataLoader: false,

  orderReportByCity: null,
  orderReportByCityLoader: false,

  topSellingProducts: null,
  topSellingProductsLoader: false,

  orderSalesByTypeYear: null,
  orderSalesByTypeYearLoader: false,

  orderReportAvg: null,
  orderReportAvgLoader: false,

  orderReportByDays: null,
  orderReportByDaysLoader: false,
};

export const getTopSellingProductsData = createAsyncThunk(
  "getTopSellingProductsData",
  async (param, thunkAPI) => {
    const res = await getTopSellingProducts(param);
    console.log("getTopSellingProductsData", res);

    return res;
  }
);
export const getTableSaleAmtDataByMonth = createAsyncThunk(
  "getTableSaleAmtDataByMonth",
  async (param, thunkAPI) => {
    const res = await getOrderSummaryAnalysis(param);
    console.log("getTableSaleAmtDataByMonth", res);

    return { details: res?.details, type: param?.type };
  }
);
export const getTableSaleAmtDataByMonthPreviousYear = createAsyncThunk(
  "getTableSaleAmtDataByMonthPreviousYear",
  async (param, thunkAPI) => {
    const res = await getOrderSummaryAnalysis(param);
    console.log("getTableSaleAmtDataByMonthPreviousYear", res);

    return { details: res?.details, type: param?.type };
  }
);

export const getSaleAmtDataByYear = createAsyncThunk(
  "getSaleAmtDataByYear",
  async (param, thunkAPI) => {
    const res = await getOrderSummaryAnalysis(param);
    console.log("getSaleAmtDataByYear", res);

    return res;
  }
);
export const getOrderReportByCityData = createAsyncThunk(
  "getOrderReportByCityData",
  async (param, thunkAPI) => {
    const res = await getOrderReportByCity(param);
    console.log("getOrderReportByCity", res);

    return res;
  }
);

export const getOrderReportAvgData = createAsyncThunk(
  "getOrderReportAvgData",
  async (param, thunkAPI) => {
    const res = await getOrderReportAvg(param);
    console.log("getOrderReportAvgData", res);

    return res;
  }
);

export const getOrderReportByTypeYearData = createAsyncThunk(
  "getOrderReportByTypeYearData",
  async (param, thunkAPI) => {
    const res = await getOrderReportByType(param);
    console.log("getOrderReportByTypeYearData", res);

    return res;
  }
);

export const getOrderReportByDaysData = createAsyncThunk(
  "getOrderReportByDaysData",
  async (param, thunkAPI) => {
    const res = await getOrderSummaryAnalysis(param);
    console.log("getOrderReportByDaysData", res);

    return res;
  }
);

export const orderSummary = createSlice({
  name: "orderSummary",
  initialState,
  reducers: {},
  extraReducers: {
    //TopSelling Products
    [getTopSellingProductsData.pending]: (state) => {
      state.topSellingProductsLoader = true;
      state.topSellingProducts = null;
    },
    [getTopSellingProductsData.fulfilled]: (state, { payload }) => {
      state.topSellingProducts = payload?.details;
      state.topSellingProductsLoader = false;
    },
    [getTopSellingProductsData.rejected]: (state, { payload }) => {
      state.topSellingProductsLoader = false;
      state.topSellingProducts = null;
    },

    //Table Month Data
    [getTableSaleAmtDataByMonth.pending]: (state) => {
      state.orderSaleAmtTableMonthDataLoader = true;
      state.orderSaleAmtTableMonthData = null;
    },
    [getTableSaleAmtDataByMonth.fulfilled]: (state, { payload }) => {
      // state.orderSaleAmtTableMonthData =
      //   payload?.details?.length > 0
      //     ? payload?.type === "year"
      //       ? transformSalesData(payload?.details)
      //       : transformDateRangeSalesData(payload?.details)
      //     : [];

      state.orderSaleAmtTableMonthData =
        payload?.details?.length > 0
          ? payload?.type === "year"
            ? transformSalesData(payload?.details)
            : payload?.type === "month"
            ? transformDateRangeSalesData(payload?.details)
            : transformDateRangeSalesDataByDay(payload?.details)
          : [];
      state.orderSaleAmtTableMonthDataLoader = false;
    },
    [getTableSaleAmtDataByMonth.rejected]: (state, { payload }) => {
      state.orderSaleAmtTableMonthDataLoader = false;
      state.orderSaleAmtTableMonthData = null;
    },
    //Table Month Data Previous Year PreviousYear
    [getTableSaleAmtDataByMonthPreviousYear.pending]: (state) => {
      state.orderSaleAmtTableMonthPreviousYearDataLoader = true;
      state.orderSaleAmtTableMonthPreviousYearData = null;
    },
    [getTableSaleAmtDataByMonthPreviousYear.fulfilled]: (
      state,
      { payload }
    ) => {
      state.orderSaleAmtTableMonthPreviousYearData =
        payload?.details?.length > 0
          ? payload?.type === "year"
            ? transformSalesData(payload?.details)
            : transformDateRangeSalesData(payload?.details)
          : [];
      state.orderSaleAmtTableMonthPreviousYearDataLoader = false;
    },
    [getTableSaleAmtDataByMonthPreviousYear.rejected]: (state, { payload }) => {
      state.orderSaleAmtTableMonthPreviousYearDataLoader = false;
      state.orderSaleAmtTableMonthPreviousYearData = null;
    },
    //Year Data
    [getSaleAmtDataByYear.pending]: (state) => {
      state.orderSaleAmtYearDataLoader = true;
      state.orderSaleAmtYearData = null;
    },
    [getSaleAmtDataByYear.fulfilled]: (state, { payload }) => {
      state.orderSaleAmtYearData = payload?.details;
      state.orderSaleAmtYearDataLoader = false;
    },
    [getSaleAmtDataByYear.rejected]: (state, { payload }) => {
      state.orderSaleAmtYearDataLoader = false;
      state.orderSaleAmtYearData = null;
    },
    //Order Report By City
    [getOrderReportByCityData.pending]: (state) => {
      state.orderReportByCityLoader = true;
      state.orderReportByCity = null;
    },
    [getOrderReportByCityData.fulfilled]: (state, { payload }) => {
      state.orderReportByCity = payload?.details;
      state.orderReportByCityLoader = false;
    },
    [getOrderReportByCityData.rejected]: (state, { payload }) => {
      state.orderReportByCityLoader = false;
      state.orderReportByCity = null;
    },
    //Order Report By Type
    [getOrderReportByTypeYearData.pending]: (state) => {
      state.orderSalesByTypeYearLoader = true;
      state.orderSalesByTypeYear = null;
    },
    [getOrderReportByTypeYearData.fulfilled]: (state, { payload }) => {
      state.orderSalesByTypeYear = payload?.details;
      state.orderSalesByTypeYearLoader = false;
    },
    [getOrderReportByTypeYearData.rejected]: (state, { payload }) => {
      state.orderSalesByTypeYearLoader = false;
      state.orderSalesByTypeYear = null;
    },
    //Order Report Avg
    [getOrderReportAvgData.pending]: (state) => {
      state.orderReportAvgLoader = true;
      state.orderReportAvg = null;
    },
    [getOrderReportAvgData.fulfilled]: (state, { payload }) => {
      state.orderReportAvg = payload?.data || [];
      state.orderReportAvgLoader = false;
    },
    [getOrderReportAvgData.rejected]: (state, { payload }) => {
      state.orderReportAvgLoader = false;
      state.orderReportAvg = null;
    },

    //Report Days Data
    [getOrderReportByDaysData.pending]: (state) => {
      state.orderReportByDaysLoader = true;
      state.orderReportByDays = null;
    },
    [getOrderReportByDaysData.fulfilled]: (state, { payload }) => {
      state.orderReportByDays = payload?.details
        ? formatDaysTimePeriod(payload?.details)
        : [];
      state.orderReportByDaysLoader = false;
    },
    [getOrderReportByDaysData.rejected]: (state, { payload }) => {
      state.orderReportByDaysLoader = false;
      state.orderReportByDays = null;
    },
  },
});

export const orderSummaryReducer = orderSummary.reducer;
